import React, { useState } from "react";

const ContactFooter = () => {

  return (
    <footer
    style={{
        position: 'relative',
        bottom: 0,
        zIndex: 99,
        textAlign: 'center',
        backgroundColor: 'rgba(16, 15, 28, 1)',
        color: '#ffffff',
        marginBottom: 0,
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    }}
    >
    <p className="big-content-text" style={{ padding: '2rem 0', margin: 0 }}>
        <a href="mailto:doquantumresearch@gmail.com" className="link-text">doquantumresearch@gmail.com ↗</a>
    </p>
    </footer>

  );
};

export default ContactFooter;